import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJp = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	id: "flag-icons-jp",
	viewBox: "0 0 640 480",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "a",
		children: /* @__PURE__ */ _jsx("path", {
			fillOpacity: .7,
			d: "M-88 32h640v480H-88z"
		})
	}) }), /* @__PURE__ */ _jsxs("g", {
		fillRule: "evenodd",
		strokeWidth: "1pt",
		clipPath: "url(#a)",
		transform: "translate(88 -32)",
		children: [/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M-128 32h720v480h-720z"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 523.1,
			cy: 344.1,
			r: 194.9,
			fill: "#bc002d",
			transform: "translate(-168.4 8.6) scale(.76554)"
		})]
	})]
});
export default SvgJp;
